import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
    selector: '[tooltipIfTruncated]',
    providers: [MatTooltip],
    standalone: false
})
export class TooltipIfTruncatedDirective implements OnInit {
  @Input('tooltipIfTruncated') tooltipText: string = '';
  @Input() targetSelector?: string;

  private styleElement: HTMLStyleElement | null = null;

  constructor(private readonly el: ElementRef<HTMLElement>, private readonly tooltip: MatTooltip) {}

  ngOnInit(): void {
    this.tooltip.tooltipClass = 'custom-tooltip-no-truncation';
  }

  @HostListener('mouseenter') onMouseEnter(): void {
    const element = this.getTargetElement();
    if (!element) { return; }

    const isTruncated: boolean = element.scrollWidth > element.offsetWidth;
    if (isTruncated) {
        this.tooltip.message = this.tooltipText;
        const hostElement: HTMLElement = this.el.nativeElement;
        const referenceElement: HTMLElement = hostElement.offsetWidth > 0 ? hostElement : element;
        this.setTooltipWidthAndPosition(referenceElement);
        this.tooltip.show();
    }
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    this.tooltip.hide();
    this.removeTooltipStyles();
  }

  private getTargetElement(): HTMLElement | null {
    if (this.targetSelector) {
      const childElement: Element | null = this.el.nativeElement.querySelector(this.targetSelector);
      return childElement instanceof HTMLElement ? childElement : this.el.nativeElement;
    } else {
      return this.el.nativeElement;
    }
  }

  private setTooltipWidthAndPosition(referenceElement: HTMLElement): void {
    const rawElementWidth: number = referenceElement.offsetWidth;
    const elementWidth: number = Number.isFinite(rawElementWidth) ? Math.max(0, Math.min(rawElementWidth, 9999)) : 0;

    const rawElementLeft: number = referenceElement.getBoundingClientRect().left;
    const elementLeft: number = Number.isFinite(rawElementLeft) ? Math.max(-9999, Math.min(rawElementLeft, 9999)) : 0;

    if (!this.styleElement) {
      this.styleElement = document.createElement('style');
      document.head.appendChild(this.styleElement);
    }

    this.styleElement.textContent = `
      .mat-tooltip.custom-tooltip-no-truncation  {
        max-width: ${elementWidth}px !important;
        width: ${elementWidth}px !important;
        left: ${elementLeft}px !important;
      }
    `;
  }

  private removeTooltipStyles(): void {
    if (this.styleElement && this.styleElement.parentNode) {
      this.styleElement.parentNode.removeChild(this.styleElement);
      this.styleElement = null;
    }
  }
}
